import { render, staticRenderFns } from "./DeliveryAdress.vue?vue&type=template&id=77a950e1"
import script from "./DeliveryAdress.vue?vue&type=script&lang=ts"
export * from "./DeliveryAdress.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports